import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { IMAGES, offerIncludes } from '../data/toolkit';
export function OfferSection() {
  return <section id="offer" className="scroll-mt-4 border-y border-navy-line bg-ivory-deep py-11 sm:py-14" aria-labelledby="offer-title" data-id="element-60" data-mp="8mwzofpw5hbb">
      <div className="mx-auto w-full max-w-[42rem] px-4 text-center sm:px-6 lg:max-w-3xl" data-id="element-61" data-mp="dg8306vhvfyh">
        <p className="eyebrow text-[0.66rem] font-semibold text-teal sm:text-[0.72rem]" data-id="element-62" data-mp="ifb0n695ajwf">
          Get the complete system today
        </p>
        <h2 id="offer-title" className="mt-3 font-display text-[1.9rem] leading-[1.12] tracking-tight text-navy sm:text-[2.4rem]" data-id="element-63" data-mp="rdenc5vv9mpt">
          Stop rebuilding your OT workflow from scratch.
        </h2>
        <p className="mx-auto mt-4 max-w-[34rem] text-[0.98rem] leading-relaxed text-navy-muted" data-id="element-64" data-mp="2t6kwk3kz62qp">
          Get OT Clinical Toolkit™ and bring assessment, planning, intervention
          and progress tracking into one organized professional resource system.
        </p>

        <img src={IMAGES.bundle} alt="The complete OT Clinical Toolkit™ bundle of six volumes with printed worksheets and reference cards." className="mx-auto -mb-1 mt-5 w-full max-w-[25rem] sm:max-w-[28rem]" data-id="element-65" data-mp="xwa1gimpoed5" />

        <div className="mt-6 rounded-2xl border border-navy-line bg-white p-5 shadow-lift sm:p-8" data-id="element-66" data-mp="oxybmito5klr">
          <h3 className="font-display text-[1.15rem] leading-snug text-navy sm:text-[1.35rem]" data-id="element-67" data-mp="1lll465nmgitx">
            Get the complete OT Clinical Toolkit™
          </h3>
          <p className="mt-1.5 text-[0.9rem] font-semibold text-teal-deep" data-id="element-68" data-mp="1ckn05nd6obbc">
            6 Professional Volumes + 5 Practical Bonuses
          </p>

          <ul className="mx-auto mt-5 max-w-sm space-y-2 text-left" data-id="element-69" data-mp="17oxxhb5vaeat">
            {offerIncludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-70" data-mp="3scu3c28hj3sc">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-71" data-mp="3sbj0c4mv602a" />
                <span className="text-[0.92rem] font-medium text-navy" data-id="element-72" data-mp="2o85hjjh3k65">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="mt-6 border-t border-navy-line pt-6" data-id="element-73" data-mp="3kvnsxij408k5">
            <p className="text-[0.85rem] text-navy-muted" data-id="element-74" data-mp="3otlg6ftbkkkw">
              Complete Resource Value:{' '}
              <span className="font-medium line-through" data-id="element-75" data-mp="3b1x7ynm6yg97">$97</span>
            </p>
            <p className="mt-2 font-display text-[4.5rem] font-semibold leading-[0.85] text-navy sm:text-[5.5rem]" data-id="element-76" data-mp="3fv9tupzhk8y9">
              $27
            </p>
            <p className="mt-2.5 text-[0.72rem] font-bold uppercase tracking-[0.18em] text-navy-muted" data-id="element-77" data-mp="313hggjj954z6">
              One-time payment
            </p>

            <CtaButton label="Get instant access" action="checkout" size="lg" className="mt-5" data-id="element-78" data-mp="2s5p1xhlcu1cu" />
            <p className="mt-3 text-[0.82rem] text-navy-muted" data-id="element-79" data-mp="2dhowb9a6q4c6">
              Instant digital access
            </p>
          </div>
        </div>

        <div className="mx-auto mt-5 flex max-w-xl items-start gap-3 text-left" data-id="element-80" data-mp="28kf09asaiufd">
          <ShieldCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-teal" aria-hidden="true" data-id="element-81" data-mp="2mjoei4wxregp" />
          <div data-id="element-82" data-mp="2ifqezt3p81n4">
            <h3 className="text-[0.72rem] font-bold uppercase tracking-[0.14em] text-navy" data-id="element-83" data-mp="2ijeauywm9050">
              7-day money-back guarantee
            </h3>
            <p className="mt-1 text-[0.85rem] leading-relaxed text-navy-muted" data-id="element-84" data-mp="2rgonanl66vbi">
              Explore OT Clinical Toolkit™ for seven days. If it isn’t the
              right fit for your professional workflow, contact us within the
              guarantee period according to the stated refund policy.
            </p>
          </div>
        </div>
      </div>
    </section>;
}